import { NavTreeItem } from "../../../../components/common/navigation";
import { useTranslation } from "../../../../hooks/useTranslation";
import { UserRole } from "../../../../models/user.model";

const ALL_ROLES: UserRole[] = [UserRole.User, UserRole.Manager, UserRole.Admin];

// Static-content topic — no backend data, so this is a single leaf NavTreeItem
// with no children, same shape as the Profile Completion topic's final design.
export const useSkillsMatrixFaqTree = (): NavTreeItem | null => {
    const { t } = useTranslation();

    return {
        id: "skills-matrix",
        label: t("FAQ_TOPIC_SKILLS_MATRIX", undefined, "Skills Self-Assessment"),
        path: "skills-matrix",
        requiredRoles: ALL_ROLES,
    };
};
